import { MenuButton } from "~/components/Header/MenuButton";
import "./style.css";
import type React from "react";
import { useContext } from "react";
import { Link } from "react-router";
import { LanguageSwitcher } from "~/components/Header/LanguageSwitcher";
import { LogoutButton } from "~/components/Header/LogoutButton";
import { SessionContext } from "~/ory";

interface Props {
	withLanguageSwitch?: boolean;
}

export const Header: React.FC<Props> = ({ withLanguageSwitch }) => {
	const session = useContext(SessionContext);

	return (
		<header className="header flex justify-between">
			<Link to="/" className="flex items-center">
				<img width="91" src="/images/logo.white.svg" alt="logo" />
			</Link>
			<div className="flex items-center gap-10">
				{session && <LogoutButton />}
				{withLanguageSwitch && <LanguageSwitcher />}
				<MenuButton />
			</div>
		</header>
	);
};

export * from "./LanguageSwitcher";
export * from "./useLanguage";
